import axios from 'axios';
import { API_BASE_URL, endpoints } from './config';

// Create an axios instance with default configuration
const apiClient = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  params: { lang: 'en' }, // Default language
});

// Fetch the list of awareness threats with optional group filtering by name
export const fetchAwareness = async ({ lang, group }) => {
  try {
    const response = await apiClient.get(endpoints.awareness.list, {
      params: {
        lang, // Overrides default if provided
        group, // Pass group name as a string
      },
    });
    console.log('Awareness Threats Data:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching awareness threats:', error);
    throw new Error(error.response?.data?.detail || 'Failed to fetch awareness threats');
  }
};

// Fetch details for a specific awareness threat by group and threat type
export const fetchAwarenessThreatDetail = async ({ group, threatType, lang }) => {
  try {
    const response = await apiClient.get(`/threats/${encodeURIComponent(group)}/${encodeURIComponent(threatType)}/`, {
      params: {
        lang, // Overrides default if provided
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching awareness threat details for ${group}/${threatType}:`, error);
    throw new Error(error.response?.data?.detail || `Failed to fetch details for ${group}/${threatType}`);
  }
};

// Fetch the list of threat types
export const fetchThreatTypes = async () => {
  try {
    const response = await apiClient.get(endpoints.awareness.threatTypes);
    return response.data;
  } catch (error) {
    console.error('Error fetching threat types:', error);
    throw new Error(error.response?.data?.detail || 'Failed to fetch threat types');
  }
};